"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBookInspectionDto = instanceOfBookInspectionDto;
exports.BookInspectionDtoFromJSON = BookInspectionDtoFromJSON;
exports.BookInspectionDtoFromJSONTyped = BookInspectionDtoFromJSONTyped;
exports.BookInspectionDtoToJSON = BookInspectionDtoToJSON;
exports.BookInspectionDtoToJSONTyped = BookInspectionDtoToJSONTyped;
/**
 * Check if a given object implements the BookInspectionDto interface.
 */
function instanceOfBookInspectionDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('inspectionType' in value) || value['inspectionType'] === undefined)
        return false;
    return true;
}
function BookInspectionDtoFromJSON(json) {
    return BookInspectionDtoFromJSONTyped(json, false);
}
function BookInspectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'listingId': json['listingId'],
        'inspectionType': json['inspectionType'],
        'listingInspectionId': json['listingInspectionId'] == null ? undefined : json['listingInspectionId'],
        'inspectionStartTime': json['inspectionStartTime'] == null ? undefined : json['inspectionStartTime'],
        'inspectionEndTime': json['inspectionEndTime'] == null ? undefined : json['inspectionEndTime'],
    };
}
function BookInspectionDtoToJSON(json) {
    return BookInspectionDtoToJSONTyped(json, false);
}
function BookInspectionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'name': value['name'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
        'listingId': value['listingId'],
        'inspectionType': value['inspectionType'],
        'listingInspectionId': value['listingInspectionId'],
        'inspectionStartTime': value['inspectionStartTime'],
        'inspectionEndTime': value['inspectionEndTime'],
    };
}
